(function ($) {

    $(document).ready(function () {

        $('html').addClass('add-overflow');

    });

    $(document).on('click', '#swiper-membership-benefits-section .swiper-pagination-bullet', function () {

        let offsetValue = 240
        if (window.matchMedia('(max-width: 768px)').matches) {
            offsetValue = 120;
        }

        $('html, body').animate({
            scrollTop: $('#swiper-membership-benefits-section').offset().top - offsetValue,
        }, 500);

    });

})(jQuery);

